import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ProtocolUpsell() {
  const comparisons = [{
    sit: 'Terminás de leer el Tomo 1',
    bad: 'No sabés por dónde empezar',
    good: 'Sabés exactamente qué hacer mañana'
  }, {
    sit: 'Primera semana con rutinas',
    bad: 'Implementás todo junto y te abrumás',
    good: 'Un solo cambio por día. Sin colapso.'
  }, {
    sit: 'Tu hijo tiene una crisis',
    bad: 'Improvisás la respuesta',
    good: 'Protocolo exacto. Paso a paso.'
  }, {
    sit: 'Querés medir si algo mejoró',
    bad: 'No tenés forma de saberlo',
    good: 'Diagnóstico inicial vs final visible'
  }, {
    sit: 'La escuela no colabora',
    bad: 'No sabés cómo escalar',
    good: 'Plan de acción de 5 pasos documentado'
  }, {
    sit: 'Sentís que retrocediste',
    bad: 'Te desmotivás y abandonás',
    good: 'Protocolo de retroceso. Seguís desde ahí.'
  }];
  const includes = ['📅 30 días de acción concreta — 1 página por día', '📊 Diagnóstico inicial y final para medir el progreso', '📋 5 plantillas listas para imprimir', '🛠️ Solución de problemas para retrocesos', '🗓️ Planificador semanal imprimible', '🚦 Semáforo de conducta listo para usar', '🛒 Lista de compras cerebro-saludable', '📄 Kit de cartas para la escuela resumido'];
  return <section className="py-24 px-4 bg-slate-900 border-y border-slate-800" data-id="element-307">
      <div className="max-w-5xl mx-auto" data-id="element-308">
        <div className="text-center mb-16" data-id="element-309">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-310">
            🕊️ ¿QUÉ AGREGA EL PROTOCOLO DE 30 DÍAS?
          </h2>
        </div>

        <div className="bg-slate-950 rounded-3xl border border-slate-800 overflow-hidden mb-12" data-id="element-311">
          <div className="overflow-x-auto" data-id="element-312">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-313">
              <thead data-id="element-314">
                <tr className="bg-slate-900 border-b border-slate-800" data-id="element-315">
                  <th className="p-4 text-slate-400 font-bold w-1/3" data-id="element-316">
                    Situación en casa
                  </th>
                  <th className="p-4 text-red-400 font-bold w-1/3 flex items-center gap-2" data-id="element-317">
                    <XCircle className="w-4 h-4" data-id="element-318" /> Sin el Protocolo
                  </th>
                  <th className="p-4 text-green-400 font-bold w-1/3" data-id="element-319">
                    <div className="flex items-center gap-2" data-id="element-320">
                      <CheckCircle2 className="w-4 h-4" data-id="element-321" /> Con el Protocolo
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-800/50" data-id="element-322">
                {comparisons.map((row, i) => <tr key={i} className="hover:bg-slate-900/30 transition-colors" data-id="element-323">
                    <td className="p-4 text-white font-medium" data-id="element-324">{row.sit}</td>
                    <td className="p-4 text-slate-400" data-id="element-325">{row.bad}</td>
                    <td className="p-4 text-amber-400 font-bold" data-id="element-326">{row.good}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-amber-500/10 border border-amber-500/20 rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-327">
          <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-328">
            ✅ EL PROTOCOLO INCLUYE:
          </h3>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-329">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3 bg-slate-900/50 p-3 rounded-xl border border-slate-800" data-id="element-330">
                <span className="text-slate-200 font-medium" data-id="element-331">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}